import { Button } from "@/Components/Control/Button"
import { CtrlReCaptcha } from "@/Components/ctrl/ReCaptcha"
import { FormWrapper } from "@/Components/Form"
import { Msg } from "@/Components/Msg"
import { Text } from "@/Components/Text"
import { useMediaQuery } from "@/hooks"
import { Container } from "@/Layout/Container"
import { Paper } from "@/Layout/Paper"
import { useRegisterForm } from "@usher/pe-client-front-end-lib"
import { Link, useParams } from "react-router-dom"
import {
  AgreeAgeCheck,
  AgreeRefundCheck,
  AgreeRiskCheck,
  AgreeTermCheck,
  ExposedPersonsCheck,
} from "./Checkboxes"
import { CorporateForm } from "./CorporateForm"
import { PersonalForm } from "./PersonalForm"
import "./style.css"
import { TypeSelect } from "./TypeSelect"
import { VerifyModal } from "./VerifyModal"

interface IRegisterFormProps {
  isForCard?: boolean
}
export const Register = ({ isForCard = false }: IRegisterFormProps) => {
  const { type } = useParams<{ type: string }>()
  const isTablet = useMediaQuery("(max-width: 992px)")
  const isCompany = type === "corporate"
  const { captchaRef, loading, formMethods, modalProps, onSubmit, modalOnClose, onCaptchaChange } =
    useRegisterForm({ registerCompany: isCompany })
  return (
    <div className="register_wrapper">
      <VerifyModal {...modalProps} handleClose={modalOnClose} />
      <Container>
        <div className="register-type-select">
          <TypeSelect darkMode={isForCard} />
        </div>
        {!isForCard && (
          <div className="register_form_head">
            <Text>
              <Msg id="registration" />
            </Text>
            <Text variant="subtitle">
              <Msg id="registered" />?{" "}
              <Link to="/login">
                <Msg id="login" />
              </Link>
            </Text>
          </div>
        )}
        {/* @ts-ignore */}
        <FormWrapper noValidate methods={formMethods} onSubmit={onSubmit}>
          <Paper>
            <div className="register__grid">
              {isCompany ? (
                <CorporateForm isTablet={isTablet} forCard={isForCard} />
              ) : (
                <PersonalForm isTablet={isTablet} forCard={isForCard} />
              )}
            </div>
            <div className="policy" style={{ maxWidth: "600px" }}>
              <AgreeTermCheck />
              <AgreeRiskCheck />
              <AgreeRefundCheck />
              <AgreeAgeCheck />
              <ExposedPersonsCheck />
            </div>

            <CtrlReCaptcha refObj={captchaRef as never} onChange={onCaptchaChange} />
            <Button loading={loading} style={{ marginTop: 49 }} type="submit">
              <Msg id="registration" />
            </Button>
          </Paper>
        </FormWrapper>
      </Container>
    </div>
  )
}
